module.exports = __webpack_public_path__ + "img/logo.e6843353.svg";